export const gameCategories = [
  {
    name: "Bingo Games",
    metaTitle: "Bingo Learning Games",
    metaDescription:
      "ABCya's bingo games are perfect for kids ages 4-12! Enjoy the thrill of chance while practicing your math, geography, and language arts skills. Play now!",
    description:
      "Enjoy the thrill of chance while collecting Bingo Bugs and practicing your math, geography, and language arts skills! This classic collection of games will have you shouting “Bingo!”",
    shortname: "bingo",
    metaKeywords: [
      "game",
      "kids",
      "educational",
      "games",
      "apps",
      "elementary",
      "primary",
      "learning",
      "learn",
      "fun",
      "bingo",
      "bingo games",
      "abcya bingo",
      "math bingo",
      "alphabet bingo",
      "number bingo",
      "state bingo",
      "money bingo",
      "dolch site word bingo",
      "base ten bingo",
      "shapes & colors bingo",
      "equivalent fractions bingo",
      "world bingo",
      "spanish word bingo",
    ],
    order: 0,
    type: "genre",
  },
  {
    name: "Crossword Games",
    metaTitle: "Crossword Learning Games",
    metaDescription:
      "ABCya has crossword games for every occasion! Practice reading skills by solving our holiday puzzles, or create your own crossword to challenge your friends.",
    description:
      "Looking to celebrate a holiday? Solve a themed crossword puzzle or make your own with ABCya's collection of crossword games!",
    shortname: "crossword",
    metaKeywords: [
      "game",
      "kids",
      "educational",
      "games",
      "apps",
      "elementary",
      "primary",
      "learning",
      "learn",
      "fun",
      "crossword puzzle",
      "crossword, christmas crossword",
      "crossword puzzle creator",
      "make a crossword puzzle",
      "earth day crossword",
      "easter crossword",
      "halloween crossword",
      "hanukkah crossword",
      "independence day crossword",
      "martin luther king jr day crossword",
      "mlk crossword",
      "memorial day crossword",
      "new years day crossword",
      "presidents day crossword",
      "st patricks day crossword",
      "thanksgiving crossword",
      "valentines day crossword",
    ],
    order: 1,
    type: "genre",
  },
  {
    name: "Hunt Games",
    metaTitle: "Hunt Learning Games",
    metaDescription:
      "Better grab a magnifying glass! Kids must find all the hidden treasures across increasingly difficult levels in ABCya's holiday-themed hunt games.",
    description:
      "Better grab a magnifying glass! Can you find all the hidden treasures in the increasingly hard levels? Try your hand at one of ABCya's hunt games!",
    shortname: "hunt",
    metaKeywords: [
      "game",
      "kids",
      "educational",
      "games",
      "apps",
      "elementary",
      "primary",
      "learning",
      "learn",
      "fun",
      "hunt games",
      "christmas hunt",
      "easter hunt",
      "halloween hunt",
      "hanukkah hunt",
      "st patricks hunt",
      "valentines hunt",
    ],
    order: 2,
    type: "genre",
  },
  {
    name: "Multiplayer Games",
    metaTitle: "Multiplayer Learning Games",
    metaDescription:
      "Do your kids want some friendly competition? Go head-to-head in local or online multiplayer games while learning about math, words, and good sportsmanship!",
    description:
      "Want some friendly competition? With ABCya's multiplayer collection, you can go head-to-head in local or online multiplayer games and see who's the best at math, language arts, and more!",
    shortname: "multiplayer",
    metaKeywords: [
      "game",
      "kids",
      "educational",
      "games",
      "apps",
      "elementary",
      "primary",
      "learning",
      "learn",
      "fun",
      "multiplayer games",
      "arcademic games",
      "racing games",
      "multiplayer",
    ],
    order: 3,
    type: "genre",
  },
  {
    name: "Platformer Games",
    metaTitle: "Platformer Learning Games",
    metaDescription:
      "Our platformer games are tons of fun for kids ages 4-12! Run and jump through factories, jungles, and circuses. Collect coins and set high scores. Play now!",
    description:
      "Platformer games are classic for a reason! Run and jump your way through factories, jungles, and even a circus while collecting coins and setting high scores.",
    shortname: "platformer",
    metaKeywords: [
      "game",
      "kids",
      "educational",
      "games",
      "apps",
      "elementary",
      "primary",
      "learning",
      "learn",
      "fun",
      "platformers",
      "platformer",
      "platform",
      "jump",
    ],
    order: 4,
    type: "genre",
  },
  {
    name: "Puzzle Games",
    metaTitle: "Puzzle Learning Games",
    metaDescription:
      "Looking for a challenge? Kids ages 4 through 12 will need to use lots of skill and strategy to conquer ABCya's puzzle games. Time to flex those brain muscles!",
    description:
      "Looking for a challenge? You'll need to use lots of skill and strategy to conquer ABCya's many puzzle games. Time to flex those brain muscles!",
    shortname: "puzzle",
    metaKeywords: [
      "game",
      "kids",
      "educational",
      "games",
      "apps",
      "elementary",
      "primary",
      "learning",
      "learn",
      "fun",
      "puzzle games",
      "puzzle",
      "logic puzzle",
      "number puzzle",
      "programming game",
      "educational puzzle",
      "physics puzzle",
      "math puzzle",
    ],
    order: 5,
    type: "genre",
  },
  {
    name: "Racing Games",
    metaTitle: "Racing Learning Games",
    metaDescription:
      "Step into the fast lane! With ABCya's racing games, kids can practice typing, math skills, and more, while striving to be the first one to the finish line!",
    description:
      "Step into the fast lane! Whether you're racing as a car, plane, or one of many animals, you'll need to hone your math and typing skills (and speed!) to be the first one to the finish line!",
    shortname: "racing",
    metaKeywords: [
      "game",
      "kids",
      "educational",
      "games",
      "apps",
      "elementary",
      "primary",
      "learning",
      "learn",
      "fun",
      "racing games",
      "race",
      "cars",
      "race cars",
      "jet ski",
      "derby",
      "educatitonal racing games",
    ],
    order: 6,
    type: "genre",
  },
  {
    name: "Word Search Games",
    metaTitle: "Word Search Learning Games",
    metaDescription:
      "ABCya has word search games for every occasion! Practice reading skills by finding the right words, or create your own word search to challenge your friends.",
    description:
      "Can you find all of the words? See if you can complete all of ABCya's holiday-themed word search games, or create your own word search to challenge your friends!",
    shortname: "word-search",
    metaKeywords: [
      "game",
      "kids",
      "educational",
      "games",
      "apps",
      "elementary",
      "primary",
      "learning",
      "learn",
      "fun",
      "word search",
      "word",
      "search",
      "word find",
      "christmas word search",
      "earth day word search",
      "easter wor search",
      "hanukkah word search",
      "word search creator",
      "make a word search",
      "valentines day word search",
      "halloween word search",
      "independence day word search",
      "martin luther king jr word search",
      "mlk word search",
      "memorial day word search",
      "new years day word search",
      "presidents day word search",
      "st patricks day word search",
      "thanksgiving word search",
    ],
    order: 7,
    type: "genre",
  },
  {
    name: "Art & Music Games",
    metaTitle: "Arts & Music Learning Games",
    metaDescription:
      "Draw, paint, animate and even compose a melody with ABCya's Art and Music Games. With so much variety, there's something to inspire creativity in any child!",
    description:
      "Draw, paint, animate and even write a song with ABCya's Art and Music Games. With so much variety, there's something to inspire creativity in anyone!",
    shortname: "art-music",
    metaKeywords: [
      "art",
      "music",
      "draw",
      "paint",
      "instrument",
      "fun",
      "category",
      "game",
      "kids",
      "educational",
      "games",
      "apps",
      "elementary",
      "primary",
      "learning",
      "learn",
    ],
    order: 0,
    type: "subject",
  },
  {
    name: "Language Arts Games",
    metaTitle: "Language Arts Learning Games",
    metaDescription:
      "With ABCya's suite of fun and educational games, kids will laugh their way through lessons on language arts topics ranging from alphabetical order to idioms!",
    description:
      "Want to have fun while learning the parts of speech? With ABCya's fun and educational games, you'll laugh your way through lessons on language arts topics ranging from alphabetical order to idioms.",
    shortname: "language-arts",
    metaKeywords: [
      "language",
      "arts",
      "game",
      "kids",
      "educational",
      "games",
      "apps",
      "elementary",
      "primary",
      "reading",
      "spelling",
      "letter",
      "word",
      "learning",
      "learn",
      "fun",
    ],
    order: 1,
    type: "subject",
  },
  {
    name: "Math Games",
    metaTitle: "Math Learning Games",
    metaDescription:
      "Do your kids need a little extra help with math facts? Play dozens of fun math games to master multiplication, division, addition, subtraction… and more!",
    description:
      "Do you need a little extra help with math facts? Explore dozens of fun and educational activities to practice multiplication, division, addition, subtraction… and more!",
    shortname: "math",
    metaKeywords: [
      "number",
      "numbers",
      "category",
      "game",
      "kids",
      "educational",
      "games",
      "apps",
      "elementary",
      "primary",
      "math",
      "mathematics",
      "shapes",
      "learning",
      "learn",
      "fun",
    ],
    order: 2,
    type: "subject",
  },
  {
    name: "Multiplication Games",
    metaTitle: "Multiplication Learning Games",
    metaDescription:
      "Practice multiplication skills with fun and educational games! Jump into dozens of exciting and interactive online activities to master the times tables.",
    description:
      "What better way to practice multiplication skills than with fun and educational games! Jump into dozens of fun and interactive multiplication games to master the times tables.",
    shortname: "multiplication",
    metaKeywords: [
      "multiplication",
      "multiply",
      "number",
      "numbers",
      "category",
      "game",
      "kids",
      "educational",
      "games",
      "apps",
      "elementary",
      "primary",
      "math",
      "mathematics",
      "shapes",
      "learning",
      "learn",
      "fun",
    ],
    order: 3,
    type: "subject",
  },
  {
    name: "Science Games",
    metaTitle: "Science Learning Games",
    metaDescription:
      "Eureka! Grab your lab coat and get ready to ace your next science test. Have fun while learning about the water cycle, the skeletal system… and more!",
    description:
      "Eureka! Grab your lab coat and get ready to ace your next science test. Have fun while learning about the water cycle, the skeletal system… and more!",
    shortname: "science",
    metaKeywords: [
      "science",
      "space",
      "astronomy",
      "anatomy",
      "nature",
      "weather",
      "senses",
      "game",
      "kids",
      "educational",
      "games",
      "apps",
      "elementary",
      "primary",
      "learning",
      "learn",
      "fun",
    ],
    order: 4,
    type: "subject",
  },
  {
    name: "Social Studies Games",
    metaTitle: "Social Studies Learning Games",
    metaDescription:
      "Unleash your inner pioneer with our social studies games! Join a carnival to learn the states or explore the world wonders in a hot air balloon. Play now!",
    description:
      "Unleash your inner pioneer with our social studies games! Step right up to a carnival game to learn about states, or travel around the globe in a hot air balloon to learn about the wonders of the world!",
    shortname: "social-studies",
    metaKeywords: [
      "social",
      "studies",
      "world",
      "geography",
      "people",
      "game",
      "kids",
      "educational",
      "games",
      "apps",
      "elementary",
      "primary",
      "learning",
      "learn",
      "fun",
    ],
    order: 5,
    type: "subject",
  },
  {
    name: "Typing Games",
    metaTitle: "Typing Learning Games",
    metaDescription:
      "Put your fingers to the test! Hone your typing speed and accuracy with challenging animated keyboard games for kids ages 4-12. Type type hooray!",
    description:
      "Put your fingers to the test! Hone your typing speed and accuracy through challenging keyboard games. Type type hooray!",
    shortname: "typing",
    metaKeywords: [
      "type",
      "typing",
      "game",
      "kids",
      "educational",
      "games",
      "apps",
      "elementary",
      "primary",
      "keyboard",
      "keyboarding",
      "learning",
      "learn",
      "fun",
    ],
    order: 6,
    type: "subject",
  },
  {
    name: "Writing Games",
    metaTitle: "Writing Learning Games",
    metaDescription:
      "Young writers: Hone your skills with ABCya's writing games for ages 4-12. Aspiring authors will have a blast writing everything from stories to friendly letters.",
    description:
      "Looking to practice your writing skills? ABCya's writing games are the first step toward writing your own story. It's as easy as ABC...ya!",
    shortname: "writing",
    metaKeywords: [
      "game",
      "kids",
      "educational",
      "games",
      "apps",
      "elementary",
      "primary",
      "learning",
      "learn",
      "fun",
      "writing",
      "write",
      "writing games",
      "write",
      "write a letter",
      "storymaker",
      "write a letter to santa",
    ],
    order: 7,
    type: "subject",
  },
  {
    name: "Car Games",
    metaTitle: "Car Learning Games",
    metaDescription:
      "Looking for car games for elementary school students? ABCya has lots of car activities that will keep young car enthusiasts learning and having fun! Vroommm!!!",
    description:
      "Start your engines! Build your own car, race your friends, or set out on a roadtrip with one of our high-octane car games.",
    shortname: "car",
    metaKeywords: [
      "car",
      "cars",
      "truck",
      "automobile",
      "category",
      "game",
      "kids",
      "educational",
      "games",
      "apps",
      "elementary",
      "primary",
      "learning",
      "learn",
      "fun",
    ],
    order: 0,
    type: "theme",
  },
  {
    name: "Cat Games",
    metaTitle: "Cat Learning Games",
    metaDescription:
      "Play a variety of super fun cat games that will keep your kids engaged while learning! We have the perfect game for any kid ages 4 through 10. Meow!",
    description: "Meow! Spend your nine lives aiming for a purrrfect score with ABCya's litter of fun cat games.",
    shortname: "cat",
    metaKeywords: [
      "cat",
      "cats",
      "feline",
      "kitty",
      "kitten",
      "category",
      "game",
      "kids",
      "educational",
      "games",
      "apps",
      "elementary",
      "primary",
      "learning",
      "learn",
      "fun",
    ],
    order: 1,
    type: "theme",
  },
  {
    name: "Animal Games",
    metaTitle: "Animal Learning Games",
    metaDescription:
      "Penguins and toucans and bats… oh my! Looking for educational animal games? ABCya has dozens of activities to keep kids learning and having fun!",
    description:
      "Penguins and toucans and bats… oh my! Go on a virtual safari or visit animals on the farm. Whatever your favorite animal is, there's a game for you!",
    shortname: "animal",
    metaKeywords: [
      "animal",
      "animals",
      "category",
      "game",
      "kids",
      "educational",
      "games",
      "apps",
      "elementary",
      "primary",
      "learning",
      "learn",
      "fun",
    ],
    order: 2,
    type: "theme",
  },
  {
    name: "Food Games",
    metaTitle: "Food Learning Games",
    metaDescription:
      "What better way to excite kids about learning than with food games! Scoop ice cream to learn verbs, flip pancakes to work with idioms, or bake just for fun!",
    description:
      "Yum! Scoop ice cream to learn verbs, flip pancakes to work with idioms, or make a cupcake just for fun! Whether you like to make or eat food, there are lots of delicious options!",
    shortname: "food",
    metaKeywords: [
      "food",
      "category",
      "game",
      "kids",
      "educational",
      "games",
      "apps",
      "elementary",
      "primary",
      "learning",
      "learn",
      "fun",
    ],
    order: 3,
    type: "theme",
  },
  {
    name: "Story Games",
    metaTitle: "Story Learning Games",
    metaDescription:
      "Engage young readers with ABCya story games! Explore our library of digital stories for kids or write a tale of your own. Adventure awaits on every page! ",
    description:
      "Adventure awaits on every page! Explore our library of digital stories, choose your own adventure… or write a tale of your own!",
    shortname: "story",
    metaKeywords: [
      "story",
      "stories",
      "read",
      "reading",
      "category",
      "game",
      "kids",
      "educational",
      "games",
      "apps",
      "elementary",
      "primary",
      "learning",
      "learn",
      "fun",
    ],
    order: 4,
    type: "theme",
  },
  {
    name: "Robot Games",
    metaTitle: "Robot Learning Games",
    metaDescription:
      "Beep boop boop! Power up with ABCya's animated robot games for kids ages 4 through 12. Build your own bots, navigate island terrain, and have fun!",
    description:
      "Beep boop boop… power up with ABCya's fun robot games! Navigate puzzle-filled levels or build your own robot!",
    shortname: "robot",
    metaKeywords: [
      "game",
      "kids",
      "educational",
      "games",
      "apps",
      "elementary",
      "primary",
      "learning",
      "learn",
      "fun",
      "robot",
      "robot games",
      "kids robot games",
    ],
    order: 5,
    type: "theme",
  },
  {
    name: "Sports Games",
    metaTitle: "Sports Learning Games",
    metaDescription:
      "ABCya's sports games are a homerun! Play soccer, football, basketball, and golf online while building elementary school math and language arts skills.",
    description:
      "Math and Language Arts skills are more fun to practice when you take the field. ABCya's sports games are a homerun!",
    shortname: "sports",
    metaKeywords: [
      "game",
      "kids",
      "educational",
      "games",
      "apps",
      "elementary",
      "primary",
      "learning",
      "learn",
      "fun",
      "sports",
      "sport",
      "sports games",
      "sport games",
      "basketball games",
      "football game",
      "hockey game",
      "soccer game",
      "racing game",
    ],
    order: 6,
    type: "theme",
  },
  {
    name: "Retro Games",
    metaTitle: "Retro Learning Games",
    metaDescription:
      "Kids of all ages can relive the 8-bit era of the 80s and 90s with ABCya's collection of retro-inspired games. Practice math, embark on adventures, and have fun!",
    description: "Revisit the 8-bit look of the 80s and 90s with ABCya's collection of retro-inspired games!",
    shortname: "retro",
    metaKeywords: [
      "game",
      "kids",
      "educational",
      "games",
      "apps",
      "elementary",
      "primary",
      "learning",
      "learn",
      "fun",
      "retro games",
      "8bit games",
      "8-bit games",
      "8bit",
      "8-bit",
      "8 bit",
      "pixel",
    ],
    order: 7,
    type: "theme",
  },
  {
    name: "Space Games",
    metaTitle: "Space Learning Games",
    metaDescription:
      "3… 2… 1… Blast Off! Dodge asteroids, practice typing, and learn about planets with ABCya's exciting space games for kids ages 4-12. They're out of this world!",
    description:
      "3… 2… 1… Blast Off! Dodge asteroids and learn about planets with ABCya's space games. They're out of this world!",
    shortname: "space",
    metaKeywords: [
      "game",
      "kids",
      "educational",
      "games",
      "apps",
      "elementary",
      "primary",
      "learning",
      "learn",
      "fun",
      "space games",
      "space",
      "outer space",
      "spaceship",
      "alien",
    ],
    order: 8,
    type: "theme",
  },
  {
    name: "Money Games",
    metaTitle: "Money Learning Games",
    metaDescription:
      "Ka-ching! Learn to sort coins and make change with ABCya's fun and interactive money games for ages 4-12. They'll keep kids laughing all the way to the bank!",
    description:
      "Ka-ching! Learn to sort coins and make change with ABCya money games. You'll be laughing all the way to the bank!",
    shortname: "money",
    metaKeywords: [
      "game",
      "kids",
      "educational",
      "games",
      "apps",
      "elementary",
      "primary",
      "learning",
      "learn",
      "fun",
      "money",
      "coins",
      "bills",
      "currency",
      "piggybank",
      "piggy bank",
      "counting money",
      "learn to count money",
      "money practice",
    ],
    order: 9,
    type: "theme",
  },
];

export const printableCategories = [
  {
    name: "Coloring Pages",
    metaTitle: "Coloring Pages for Kids",
    metaDescription:
      "Free printable coloring pages for kids by ABCya! Explore your favorite ABCya characters with our fun coloring activities!",
    description:
      "Free printable coloring pages for kids by ABCya! Explore your favorite ABCya characters with our fun coloring activities!",
    shortname: "coloring-pages",
    metaKeywords: ["printable", "coloring", "color", "coloring page"],
  },
  {
    name: "ABCya Characters",
    metaTitle: "ABCya Character Coloring Pages for Kids",
    metaDescription:
      "Free printable coloring pages featuring ABCya characters for kids! Explore your favorite ABCya characters with our fun coloring activities!",
    description:
      "Free printable coloring pages featuring ABCya characters for kids! Explore your favorite ABCya characters with our fun coloring activities!",
    shortname: "coloring-pages-characters",
    metaKeywords: ["printable", "coloring", "color", "coloring page", "abcya", "character", "characters"],
  },
  {
    name: "Autumn",
    metaTitle: "Autumn Coloring Pages for Kids",
    metaDescription:
      "Free Autumn themed printable coloring pages for kids by ABCya! Explore your favorite ABCya characters with our fun coloring activities!",
    description:
      "Free Autumn themed printable coloring pages for kids by ABCya! Explore your favorite ABCya characters with our fun coloring activities!",
    shortname: "coloring-pages-autumn",
    metaKeywords: ["printable", "coloring", "color", "coloring page", "autmn", "fall", "season"],
  },
  {
    name: "Spring",
    metaTitle: "Spring Coloring Pages for Kids",
    metaDescription:
      "Free Spring themed printable coloring pages for kids by ABCya! Explore your favorite ABCya characters with our fun coloring activities!",
    description:
      "Free Spring themed printable coloring pages for kids by ABCya! Explore your favorite ABCya characters with our fun coloring activities!",
    shortname: "coloring-pages-spring",
    metaKeywords: ["printable", "coloring", "color", "coloring page", "spring", "season"],
  },
  {
    name: "Summer",
    metaTitle: "Summer Coloring Pages for Kids",
    metaDescription:
      "Free Summer themed printable coloring pages for kids by ABCya! Explore your favorite ABCya characters with our fun coloring activities!",
    description:
      "Free Summer themed printable coloring pages for kids by ABCya! Explore your favorite ABCya characters with our fun coloring activities!",
    shortname: "coloring-pages-summer",
    metaKeywords: ["printable", "coloring", "color", "coloring page", "summer", "season"],
  },
  {
    name: "Halloween",
    metaTitle: "Halloween Coloring Pages for Kids",
    metaDescription:
      "Free Halloween themed printable coloring pages for kids by ABCya! Explore your favorite ABCya characters with our fun coloring activities!",
    description:
      "Free Halloween themed printable coloring pages for kids by ABCya! Explore your favorite ABCya characters with our fun coloring activities!",
    shortname: "coloring-pages-halloween",
    metaKeywords: ["printable", "coloring", "color", "coloring page", "halloween", "holiday"],
  },
  {
    name: "Activity Pages",
    metaTitle: "Activity Pages for Kids",
    metaDescription: "Printable activity pages for kids by ABCya!",
    description: "Printable activity pages for kids by ABCya!",
    shortname: "activity-pages",
    metaKeywords: ["printable", "activity", "activities", "pages", "activity pages"],
  },
  {
    name: "ABCya Characters",
    metaTitle: "ABCya Character Activity Pages for Kids",
    metaDescription: "Printable activity pages featuring ABCya characters for kids!",
    description: "Printable activity pages featuring ABCya characters for kids!",
    shortname: "activity-pages-characters",
    metaKeywords: ["printable", "activity", "activities", "pages", "activity pages", "character", "abcya"],
  },
  {
    name: "Autumn",
    metaTitle: "Autumn Activity Pages for Kids",
    metaDescription: "Printable Autumn themed activity pages for kids by ABCya!",
    description: "Printable Autumn themed activity pages for kids by ABCya!",
    shortname: "activity-pages-autumn",
    metaKeywords: ["printable", "activity", "activities", "pages", "activity pages", "autumn", "fall", "season"],
  },
  {
    name: "Spring",
    metaTitle: "Spring Activity Pages for Kids",
    metaDescription: "Printable Spring themed activity pages for kids by ABCya!",
    description: "Printable Spring themed activity pages for kids by ABCya!",
    shortname: "activity-pages-spring",
    metaKeywords: ["printable", "activity", "activities", "pages", "activity pages", "spring", "season"],
  },
  {
    name: "Summer",
    metaTitle: "Summer Activity Pages for Kids",
    metaDescription: "Printable Summer themed activity pages for kids by ABCya!",
    description: "Printable Summer themed activity pages for kids by ABCya!",
    shortname: "activity-pages-summer",
    metaKeywords: ["printable", "activity", "activities", "pages", "activity pages", "summer", "season"],
  },
  {
    name: "Halloween",
    metaTitle: "Halloween Activity Pages for Kids",
    metaDescription: "Printable Halloween themed activity pages for kids by ABCya!",
    description: "Printable Halloween themed activity pages for kids by ABCya!",
    shortname: "activity-pages-halloween",
    metaKeywords: ["printable", "activity", "activities", "pages", "activity pages", "halloween", "holiday"],
  },
  {
    name: "Worksheets",
    metaTitle: "Worksheets for Kids",
    metaDescription: "Printable worksheets for kids by ABCya!",
    description: "Printable worksheets for kids by ABCya!",
    shortname: "worksheets",
    metaKeywords: ["printable", "worksheet"],
  },
  {
    name: "Math",
    metaTitle: "Math Worksheets for Kids",
    metaDescription: "Printable Math worksheets for kids by ABCya!",
    description: "Printable Math worksheets for kids by ABCya!",
    shortname: "worksheets-math",
    metaKeywords: ["printable", "worksheet", "math", "arithmetic"],
  },
  {
    name: "Language Arts",
    metaTitle: "Language Arts Worksheets for Kids",
    metaDescription: "Printable Language Arts worksheets for kids by ABCya!",
    description: "Printable Language Arts worksheets for kids by ABCya!",
    shortname: "worksheets-language-arts",
    metaKeywords: ["printable", "worksheet", "language", "arts", "language arts"],
  },
  {
    name: "Science",
    metaTitle: "Science Worksheets for Kids",
    metaDescription: "Printable Science worksheets for kids by ABCya!",
    description: "Printable Science worksheets for kids by ABCya!",
    shortname: "worksheets-science",
    metaKeywords: ["printable", "worksheet", "science"],
  },
  {
    name: "Teacher Resources",
    metaTitle: "Teacher Resources for Kids",
    metaDescription: "Printable resources for teachers by ABCya!",
    description: "Printable resources for teachers by ABCya!",
    shortname: "teacher-resources",
    metaKeywords: ["printable", "teacher", "resource", "teacher resources"],
  },
  {
    name: "Math",
    metaTitle: "Math Teacher Resources for Kids",
    metaDescription: "Printable Math resources for teachers by ABCya!",
    description: "Printable Math resources for teachers by ABCya!",
    shortname: "teacher-resources-math",
    metaKeywords: ["printable", "teacher", "resource", "teacher resources", "math", "arithmetic"],
  },
  {
    name: "Language Arts",
    metaTitle: "Language Arts Teacher Resources for Kids",
    metaDescription: "Printable Language Arts resources for teachers by ABCya!",
    description: "Printable Language Arts resources for teachers by ABCya!",
    shortname: "teacher-resources-language-arts",
    metaKeywords: ["printable", "teacher", "resource", "teacher resources", "language", "arts", "language arts"],
  },
  {
    name: "Science",
    metaTitle: "Science Teacher Resources for Kids",
    metaDescription: "Printable Science resources for teachers by ABCya!",
    description: "Printable Science resources for teachers by ABCya!",
    shortname: "teacher-resources-science",
    metaKeywords: ["printable", "teacher", "resource", "teacher resources", "science"],
  },
  {
    name: "St. Patrick's Day",
    metaTitle: "St. Patrick's Day Activity Pages for Kids",
    metaDescription: "Printable St. Patrick's Day themed activity pages for kids by ABCya!",
    description: "Printable St. Patrick's Day themed activity pages for kids by ABCya!",
    shortname: "activity-pages-st-pat",
    metaKeywords: [
      "printable",
      "activity",
      "activities",
      "pages",
      "activity pages",
      "saint",
      "patrick",
      "st. patrick's day",
      "holiday",
    ],
  },
  {
    name: "Easter",
    metaTitle: "Easter Activity Pages for Kids",
    metaDescription: "Printable Easter themed activity pages for kids by ABCya!",
    description: "Printable Easter themed activity pages for kids by ABCya!",
    shortname: "activity-pages-easter",
    metaKeywords: ["printable", "activity", "activities", "pages", "activity pages", "easter", "holiday"],
  },
  {
    name: "Winter Holidays",
    metaTitle: "Winter Holidays Activity Pages for Kids",
    metaDescription: "Printable Winter Holidays themed activity pages for kids by ABCya!",
    description: "Printable Winter Holidays themed activity pages for kids by ABCya!",
    shortname: "activity-pages-winter-holidays",
    metaKeywords: [
      "printable",
      "activity",
      "activities",
      "pages",
      "activity pages",
      "christmas",
      "winter",
      "holiday",
      "hanukkah",
      "kwanzaa",
      "new",
      "year",
      "eve",
    ],
  },
  {
    name: "Valentine's Day",
    metaTitle: "Valentine's Day Activity Pages for Kids",
    metaDescription: "Printable Valentine's Day themed activity pages for kids by ABCya!",
    description: "Printable Valentine's Day themed activity pages for kids by ABCya!",
    shortname: "activity-pages-valentine",
    metaKeywords: [
      "printable",
      "activity",
      "activities",
      "pages",
      "activity pages",
      "valentine",
      "valentine's day",
      "saint",
      "holiday",
    ],
  },
  {
    name: "Connect the Dots",
    metaTitle: "Connect the Dots Activity Pages for Kids",
    metaDescription: "Printable connect the dots themed activity pages for kids by ABCya!",
    description: "Printable connect the dots themed activity pages for kids by ABCya!",
    shortname: "activity-pages-connect-dots",
    metaKeywords: [
      "printable",
      "activity",
      "activities",
      "pages",
      "activity pages",
      "connect",
      "dots",
      "connect the dots",
    ],
  },
  {
    name: "Maze",
    metaTitle: "Maze Activity Pages for Kids",
    metaDescription: "Printable maze themed activity pages for kids by ABCya!",
    description: "Printable maze themed activity pages for kids by ABCya!",
    shortname: "activity-pages-maze",
    metaKeywords: ["printable", "activity", "activities", "pages", "activity pages", "maze"],
  },
  {
    name: "Thanksgiving",
    metaTitle: "Thanksgiving Activity Pages for Kids",
    metaDescription: "Printable Thanksgiving themed activity pages for kids by ABCya!",
    description: "Printable Thanksgiving themed activity pages for kids by ABCya!",
    shortname: "activity-pages-thanksgiving",
    metaKeywords: [
      "printable",
      "activity",
      "activities",
      "pages",
      "activity pages",
      "holiday",
      "thanks",
      "giving",
      "thanksgiving",
    ],
  },
  {
    name: "Crossword",
    metaTitle: "Crossword Activity Pages for Kids",
    metaDescription: "Printable crossword themed activity pages for kids by ABCya!",
    description: "Printable crossword themed activity pages for kids by ABCya!",
    shortname: "activity-pages-crossword",
    metaKeywords: ["printable", "activity", "activities", "pages", "activity pages", "crossword"],
  },
  {
    name: "How Many",
    metaTitle: "How Many Activity Pages for Kids",
    metaDescription: "Printable how many themed activity pages for kids by ABCya!",
    description: "Printable how many themed activity pages for kids by ABCya!",
    shortname: "activity-pages-how-many",
    metaKeywords: ["printable", "activity", "activities", "pages", "activity pages", "how many", "how", "many"],
  },
  {
    name: "Word Scramble",
    metaTitle: "Word Scramble Activity Pages for Kids",
    metaDescription: "Printable word scramble themed activity pages for kids by ABCya!",
    description: "Printable word scramble themed activity pages for kids by ABCya!",
    shortname: "activity-pages-word-scramble",
    metaKeywords: [
      "printable",
      "activity",
      "activities",
      "pages",
      "activity pages",
      "word",
      "scramble",
      "word scramble",
    ],
  },
  {
    name: "Word Search",
    metaTitle: "Word Search Activity Pages for Kids",
    metaDescription: "Printable word search themed activity pages for kids by ABCya!",
    description: "Printable word search themed activity pages for kids by ABCya!",
    shortname: "activity-pages-word-search",
    metaKeywords: ["printable", "activity", "activities", "pages", "activity pages", "word", "search", "word search"],
  },
  {
    name: "General Resources",
    metaTitle: "Teacher Resources for Kids",
    metaDescription: "Printable resources for teachers by ABCya!",
    description: "Printable resources for teachers by ABCya!",
    shortname: "teacher-resources-general-resources",
    metaKeywords: ["printable", "resource", "resources", "teacher", "teacher resources"],
  },
  {
    name: "Social Studies",
    metaTitle: "Social Studies Worksheets for Kids",
    metaDescription: "Printable social studies worksheets for kids by ABCya!",
    description: "Printable social studies worksheets for kids by ABCya!",
    shortname: "worksheets-social-studies",
    metaKeywords: ["printable", "worksheet", "worksheets", "social", "studies"],
  },
  {
    name: "Finish the Drawing",
    metaTitle: "Finish the Drawing Activity Pages for Kids",
    metaDescription: "Printable Finish the Drawing themed activity pages for kids by ABCya!",
    description: "Printable Finish the Drawing themed activity pages for kids by ABCya!",
    shortname: "activity-pages-finish-drawing",
    metaKeywords: ["printable", "activity", "activities", "pages", "activity pages", "finish", "drawing", "holiday"],
  },
  {
    name: "U.S. Holidays",
    metaTitle: "U.S. Holidays Activity Pages for Kids",
    metaDescription: "Printable U.S. Holidays themed activity pages for kids by ABCya!",
    description: "Printable U.S. Holidays themed activity pages for kids by ABCya!",
    shortname: "activity-pages-us-holidays",
    metaKeywords: ["printable", "activity", "activities", "pages", "activity pages", "holiday", "us", "u.s."],
  },
  {
    name: "Art & Music",
    metaTitle: "Art & Music Teacher Resources for Kids",
    metaDescription: "Printable Art & Music resources for teachers by ABCya!",
    description: "Printable Art & Music resources for teachers by ABCya!",
    shortname: "teacher-resources-art-music",
    metaKeywords: ["printable", "resource", "resources", "teacher", "teacher resources", "art", "music"],
  },
  {
    name: "Social Studies",
    metaTitle: "Social Studies Teacher Resources for Kids",
    metaDescription: "Printable Social Studies resources for teachers by ABCya!",
    description: "Printable Social Studies resources for teachers by ABCya!",
    shortname: "teacher-resources-social-studies",
    metaKeywords: ["printable", "resource", "resources", "teacher", "teacher resources", "social", "studies"],
  },
  {
    name: "Skills",
    metaTitle: "Skills Teacher Resources for Kids",
    metaDescription: "Printable skills resources for teachers by ABCya!",
    description: "Printable skills resources for teachers by ABCya!",
    shortname: "teacher-resources-skills",
    metaKeywords: ["printable", "resource", "resources", "teacher", "teacher resources", "skill"],
  },
  {
    name: "Animals",
    metaTitle: "Animals Coloring Pages for Kids",
    metaDescription:
      "Free animal themed printable coloring pages for kids by ABCya! Explore your favorite ABCya characters with our fun coloring activities!",
    description:
      "Free animal themed printable coloring pages for kids by ABCya! Explore your favorite ABCya characters with our fun coloring activities!",
    shortname: "coloring-pages-animals",
    metaKeywords: ["printable", "coloring", "color", "coloring page", "abcya", "animal", "animals"],
  },
  {
    name: "Food",
    metaTitle: "Food Coloring Pages for Kids",
    metaDescription:
      "Free food themed printable coloring pages for kids by ABCya! Explore your favorite ABCya characters with our fun coloring activities!",
    description:
      "Free food themed printable coloring pages for kids by ABCya! Explore your favorite ABCya characters with our fun coloring activities!",
    shortname: "coloring-pages-food",
    metaKeywords: ["printable", "coloring", "color", "coloring page", "abcya", "food"],
  },
  {
    name: "Sports",
    metaTitle: "Sports Coloring Pages for Kids",
    metaDescription:
      "Free sports themed printable coloring pages for kids by ABCya! Explore your favorite ABCya characters with our fun coloring activities!",
    description:
      "Free sports themed printable coloring pages for kids by ABCya! Explore your favorite ABCya characters with our fun coloring activities!",
    shortname: "coloring-pages-sports",
    metaKeywords: ["printable", "coloring", "color", "coloring page", "abcya", "sport", "sports"],
  },
  {
    name: "Make-A-Note",
    metaTitle: "Make-A-Note Coloring Pages for Kids",
    metaDescription:
      "Free make-a-note themed printable coloring pages for kids by ABCya! Explore your favorite ABCya characters with our fun coloring activities!",
    description:
      "Free make-a-note themed printable coloring pages for kids by ABCya! Explore your favorite ABCya characters with our fun coloring activities!",
    shortname: "coloring-pages-make-a-note",
    metaKeywords: ["printable", "coloring", "color", "coloring page", "abcya", "make", "note", "make-a-note"],
  },
  {
    name: "Winter Holidays",
    metaTitle: "Winter Holidays Coloring Pages for Kids",
    metaDescription:
      "Free winter holidays themed printable coloring pages for kids by ABCya! Explore your favorite ABCya characters with our fun coloring activities!",
    description:
      "Free winter holidays themed printable coloring pages for kids by ABCya! Explore your favorite ABCya characters with our fun coloring activities!",
    shortname: "coloring-pages-winter-holidays",
    metaKeywords: ["printable", "coloring", "color", "coloring page", "abcya", "winter", "holiday"],
  },
  {
    name: "Valentine's Day",
    metaTitle: "Valentine's Day Coloring Pages for Kids",
    metaDescription:
      "Free Valentine's Day themed printable coloring pages for kids by ABCya! Explore your favorite ABCya characters with our fun coloring activities!",
    description:
      "Free Valentine's Day themed printable coloring pages for kids by ABCya! Explore your favorite ABCya characters with our fun coloring activities!",
    shortname: "coloring-pages-valentine",
    metaKeywords: ["printable", "coloring", "color", "coloring page", "abcya", "valentine"],
  },
  {
    name: "St. Patrick's Day",
    metaTitle: "St. Patrick's Day Coloring Pages for Kids",
    metaDescription:
      "Free St. Patrick's Day themed printable coloring pages for kids by ABCya! Explore your favorite ABCya characters with our fun coloring activities!",
    description:
      "Free St. Patrick's Day themed printable coloring pages for kids by ABCya! Explore your favorite ABCya characters with our fun coloring activities!",
    shortname: "coloring-pages-st-pat",
    metaKeywords: ["printable", "coloring", "color", "coloring page", "abcya", "st", "saint", "pat", "patrick", "day"],
  },
  {
    name: "Easter",
    metaTitle: "Easter Coloring Pages for Kids",
    metaDescription:
      "Free Easter themed printable coloring pages for kids by ABCya! Explore your favorite ABCya characters with our fun coloring activities!",
    description:
      "Free Easter themed printable coloring pages for kids by ABCya! Explore your favorite ABCya characters with our fun coloring activities!",
    shortname: "coloring-pages-easter",
    metaKeywords: ["printable", "coloring", "color", "coloring page", "abcya", "easter"],
  },
  {
    name: "U.S. Holidays",
    metaTitle: "U.S. Holidays Coloring Pages for Kids",
    metaDescription:
      "Free U.S. holidays themed printable coloring pages for kids by ABCya! Explore your favorite ABCya characters with our fun coloring activities!",
    description:
      "Free U.S. holidays themed printable coloring pages for kids by ABCya! Explore your favorite ABCya characters with our fun coloring activities!",
    shortname: "coloring-pages-us-holidays",
    metaKeywords: ["printable", "coloring", "color", "coloring page", "abcya", "us", "u.s.", "holiday"],
  },
  {
    name: "Thanksgiving",
    metaTitle: "Thanksgiving Coloring Pages for Kids",
    metaDescription:
      "Free Thanksgiving themed printable coloring pages for kids by ABCya! Explore your favorite ABCya characters with our fun coloring activities!",
    description:
      "Free Thanksgiving themed printable coloring pages for kids by ABCya! Explore your favorite ABCya characters with our fun coloring activities!",
    shortname: "coloring-pages-thanksgiving",
    metaKeywords: ["printable", "coloring", "color", "coloring page", "abcya", "thanks", "thanksgiving"],
  },
  {
    name: "Winter",
    metaTitle: "Winter Coloring Pages for Kids",
    metaDescription:
      "Free Winter themed printable coloring pages for kids by ABCya! Explore your favorite ABCya characters with our fun coloring activities!",
    description:
      "Free Winter themed printable coloring pages for kids by ABCya! Explore your favorite ABCya characters with our fun coloring activities!",
    shortname: "coloring-pages-winter",
    metaKeywords: ["printable", "coloring", "color", "coloring page", "abcya", "winter"],
  },
  {
    name: "Spot the Difference",
    metaTitle: "Spot the Difference Activity Pages for Kids",
    metaDescription: "Printable spot the difference themed activity pages for kids by ABCya!",
    description: "Printable spot the difference themed activity pages for kids by ABCya!",
    shortname: "activity-pages-spot-difference",
    metaKeywords: ["printable", "activity", "activities", "pages", "activity pages", "spot", "find", "difference"],
  },
];

export const gradeCategories = [
  {
    id: "cjek3zw11514z0164860uynht",
    name: "Letters",
    metaTitle: "Letter Learning Games",
    metaDescription: "Free Educational Word Games for Kids.",
    shortname: "letters",
    metaKeywords: [
      "letters",
      "words",
      "category",
      "game",
      "kids",
      "educational",
      "games",
      "apps",
      "elementary",
      "primary",
      "spelling",
      "reading",
      "letters",
      "learning",
      "learn",
      "fun",
    ],
  },
  {
    id: "cjek401lk51560164t8ze4vil",
    name: "Numbers",
    metaTitle: "Number Learning Games",
    metaDescription: "Free Educational Math Games for Kids.",
    shortname: "numbers",
    metaKeywords: [
      "number",
      "numbers",
      "category",
      "game",
      "kids",
      "educational",
      "games",
      "apps",
      "elementary",
      "primary",
      "math",
      "mathematics",
      "shapes",
      "learning",
      "learn",
      "fun",
    ],
  },
  {
    id: "cjek405zh515d0164v3ke85c6",
    name: "Holiday",
    metaTitle: "Holiday Learning Games",
    metaDescription: "Free Educational Holiday Games for Kids.",
    shortname: "holiday",
    metaKeywords: [
      "holiday",
      "holidays",
      "category",
      "game",
      "kids",
      "educational",
      "games",
      "apps",
      "elementary",
      "primary",
      "christmas",
      "hanukkah",
      "halloween",
      "easter",
      "valentine",
      "saint",
      "patrick",
      "learning",
      "learn",
      "fun",
    ],
  },
  {
    id: "cjek40da5515m0164hzy2uzju",
    name: "Strategy",
    metaTitle: "Strategy Learning Games",
    metaDescription: "Free Educational Strategy Games for Kids.",
    shortname: "strategy",
    metaKeywords: [
      "strategy",
      "strategies",
      "category",
      "game",
      "kids",
      "educational",
      "games",
      "apps",
      "elementary",
      "primary",
      "learning",
      "learn",
      "fun",
    ],
  },
  {
    id: "cjek40hi0515t0164lor3cf6z",
    name: "Skill",
    metaTitle: "Skill Learning Games",
    metaDescription: "Free Educational Skill Games for Kids.",
    shortname: "skill",
    metaKeywords: [
      "skill",
      "skills",
      "category",
      "game",
      "kids",
      "educational",
      "games",
      "apps",
      "elementary",
      "primary",
      "learning",
      "learn",
      "fun",
    ],
  },
];
